import { render, staticRenderFns } from "./add-sidebar-dynamic.vue?vue&type=template&id=667806f9&scoped=true&"
import script from "./add-sidebar-dynamic.vue?vue&type=script&lang=js&"
export * from "./add-sidebar-dynamic.vue?vue&type=script&lang=js&"
import style0 from "./add-sidebar-dynamic.vue?vue&type=style&index=0&id=667806f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667806f9",
  null
  
)

export default component.exports